module.exports = __webpack_public_path__ + "static/media/toyota-logo.23051395.svg";